import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-main" }
const _hoisted_2 = { class: "chart" }
const _hoisted_3 = { id: "data" }
const _hoisted_4 = { class: "card-footer ion-text-center ion-margin-top" }

import { IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonIcon } from "@ionic/vue";
import { onMounted, ref } from "vue";
import { Doughnut } from 'vue-chartjs'
import { useMotion } from "@vueuse/motion";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'

export default /*@__PURE__*/_defineComponent({
  __name: 'DoughnutChartCard',
  props: {
  subTitle: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: false
  },
  data: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    required: false
  },
  additionalInfo: {
    type: String,
    required: false
  }
},
  setup(__props) {

ChartJS.register(ArcElement, Tooltip, Legend)

const props = __props

let chartData = ref({}) as any
let chartOptions = ref({})
let primaryColor = ref("")
const card = ref()

let style = window.getComputedStyle(document.body)

onMounted(() => {
  primaryColor.value = style.getPropertyValue('--ion-color-primary')

  const value = props.data.includes("%") ? props.data.replace("%", "") : props.data

  chartData.value = {
    labels: "",
    datasets: [{
      label: "",
      data: [100 - +value, +value],
      backgroundColor: ["#676767", "transparent"],
      borderWidth: value == "0" ? "1" : "0",
      borderColor: ["", primaryColor.value]
    }]
  }

  chartOptions.value = {
    responsive: true,
    cutout: "70%",  // cutout from the center to control the chart width
    events: []  // to remove hover effect and remove tooltip(for removing tooltip we can also use plugins: { tooltip: { enabled: false } })
  }
})

const { variant } = useMotion(card, {
  initial: {
    opacity: 0,
    y: 100
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 300,
      type: 'keyframes',
      ease: 'easeIn',
    },
  }
})

return (_ctx: any,_cache: any) => {
  return (Object.keys(_unref(chartData)).length)
    ? (_openBlock(), _createBlock(_unref(IonCard), {
        key: 0,
        ref_key: "card",
        ref: card,
        class: "ion-margin"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCardHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCardSubtitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.subTitle), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCardContent), null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(Doughnut), {
                    options: _unref(chartOptions),
                    data: _unref(chartData)
                  }, null, 8, ["options", "data"]),
                  _createElementVNode("p", _hoisted_3, _toDisplayString(__props.data), 1)
                ]),
                _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1)),
                _createVNode(_unref(IonIcon), { icon: __props.icon }, null, 8, ["icon"])
              ]),
              _createElementVNode("div", _hoisted_4, _toDisplayString(__props.additionalInfo), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512))
    : _createCommentVNode("", true)
}
}

})